module.exports = __webpack_public_path__ + "media/frontend/base/typo/fonts/NeoSansMedium-web-4778accbe31830c7623e159d21bde7d2.woff2";